// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__Zp-c-","footerText":"Footer_footerText__nYq4H"};